import React from 'react';
import { getFullName } from '../../../utils';
import RenderProfilePic from '../../../extras/RenderProfilePic';
import DownloadIcon from '../../../img/download-icon.png';
import CallIcon from '../../../img/call.png';
import FavouriteIcon from '../../../img/favourite-icon.png';

export const Student = ({ student, handleSelect }) => {
  const {
    userDetails,
    cohortName,
    courseType,
    userId: id,
    userProfileDetails,
  } = student;
  const { thumbnail, email, phone } = userDetails;
  const { education } = userProfileDetails;
  const name = getFullName(userDetails);

  const getLatestExperience = () => {
    let latestExperience = '';
    if (education && education.length > 0) {
      latestExperience = `${education[0].degree} in ${education[0].stream} from ${education[0]?.university?.name}`;
    }
    return latestExperience;
  };
  return (
    <div className='grid grid-cols-12  my-5 p-3 bg-gray-50 shadow-md rounded-sm px-7'>
      <div className='col-span-8  '>
        <div className='flex'>
          <input
            type='checkbox'
            value={student.selected}
            checked={student.selected}
            onChange={(event) => {
              handleSelect(event.target.checked, id);
            }}
          />
          <div className='flex flex-col justify-between'>
            <div className='flex items-center ml-5 text-font-para font-semibold'>
              {name}
            </div>
          </div>
        </div>
        <div className='text-font-light text-xs mb-1 ml-9 mt-2 max-w-xs'>
          {getLatestExperience() || 'No experience data available'}
        </div>
      </div>

      <div className='col-span-4 pl-5 border-l flex-col'>
        <div className='flex justify-end '>
          <img src={DownloadIcon} className='hidden md:inline px-2 ' />
          <img src={FavouriteIcon} className='hidden md:inline  mx-2' />
        </div>
        <div className='pb-3'>
          <RenderProfilePic thumbnail={thumbnail} name={name} size={3} />
        </div>
        <div className='text-font-light text-xs mb-1'>{email}</div>
        <div className='text-font-light text-xs mb-1'>
          {' '}
          <span>
            {' '}
            <img src={CallIcon} className='hidden md:inline' />{' '}
          </span>{' '}
          {phone}
        </div>
        <div className='text-font-light text-xs mb-1'>
          {' '}
          {courseType ?? 'Not Available'}{' '}
        </div>
        <div className='text-font-light text-xs mb-1'>
          {' '}
          {cohortName ?? 'Not Available'}{' '}
        </div>
      </div>
    </div>
  );
};
